import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import ListPage from "@/components/ListPage";
import HomePage from "@/components/HomePage";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login/:inviteCode?",
      name: "login",
      component: Login
    },
    {
      path: "/",
      name: "home",
      component: HomePage
    },
    {
      path: "/l/:id",
      name: "list",
      component: ListPage
    }
  ]
});
